<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <div class="block">
      <el-row type="flex" justify="space-between" align="center">
        <div class="flex-box row">
          <h2 class="title">全部通知</h2>
        </div>
        <div class="flex-box row">
          <el-input
            placeholder="搜索通知"
            class="max-width-200 w-a"
            suffix-icon="el-icon-search"
            v-model="search">

          </el-input>
        </div>
      </el-row>
      <el-table :data="page" border style="width: 100%;cursor: pointer" @row-click="openNotice">
        <template slot="empty">
          <div v-if="ready">
            <div v-if="!notices.length">暂无通知</div>
            <div v-else-if="!filtered.length">无匹配结果</div>
          </div>
        </template>
        <el-table-column v-for="item in notice_form" :prop="item.prop" :label="item.name" :key="item.prop">
          <template slot-scope="scope">
            <span
              :class="{'bold': scope.row.status === '1','light': scope.row.status === '0'}"
              v-html="$highlight(scope.row[item.prop], scope.row.$$pinyin[item.prop])">
              {{scope.row[item.prop]}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="filtered.length>pageInfo.page"
        :total="filtered.length"
        :page-size="pageInfo.page"
        :current-page.sync="pageInfo.current"
        class="text-center m-t-10" layout="prev, pager, next">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import * as Home from 'api/home'
import Filer from 'lodash/filter'
import Matches from 'lodash/matches'
import page from 'utils/page'

export default {
  data () {
    return {
      notices: null,
      notice_form: null,
      ready: false,
      pageInfo: {page: 20, current: 1},
      search: '',
    }
  },
  computed: {
    filtered () {
      return this.$search(this.notices, this.search, ['title', 'department'])
    },
    page () {
      return page(this.filtered, this.pageInfo)
    },
    unread () {
      // 过滤过的未读条数
      return Filer(this.filtered, Matches({'status': '1'})).length
    },
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [notices, notice_form] = await Promise.all([Home.list(), Home.notice_form_brief()])
        this.notices = notices
        this.notice_form = notice_form
        this.ready = true
        this.search = this.$query.search ? this.$query.search : ''
        this.pageInfo.current = this.$query.current ? parseInt(this.$query.current) : 1
      })
    },
    async openNotice (row) {
      try {
        await Home.set_notice_detail(row)
        this.$router.push(this.$location.notice_detail({
          notice_uid: row.uid,
          search: this.search,
          current: this.pageInfo.current,
          pre_page: 'all_notice',
        }, false))
      } catch (e) {
        this.$handleError(e)
      }
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss">
@import 'src/scss/var/colors';

.title {
  color: $color-primary;
}

.bold {
  color: black;
}

.light {
  color: #8c939d;
}

.flex-box {
  display: flex;
  &.column {
    align-items: flex-start;
    flex-direction: column;
  }
  &.row {
    align-items: center;
    flex-direction: row;
  }
}

.block {
  background: white;
  padding: 0 20px 20px 20px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/NoticeList.vue